import React from "react";

const NewAdminDashboard: React.FC = () => {

  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0 }}>
      <iframe
        src="https://new-admin-dashboard-fe.mylavni.com/?secret=andie-mylavni"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0
        }}
        title="New Admin Dashboard"
      />
    </div>
  );
};

export default NewAdminDashboard; 